import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import BeginnerGuidePage from "@/pages/beginner-guide/page";
import ShoesGuidePage from "@/pages/shoes-guide/page";
import ShippingGuidePage from "@/pages/shipping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-spreadsheet-beginner-guide",
    element: <BeginnerGuidePage />,
  },
  {
    path: "/superbuy-spreadsheet-shoes-guide",
    element: <ShoesGuidePage />,
  },
  {
    path: "/superbuy-spreadsheet-shipping-guide",
    element: <ShippingGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;